import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "62",
  height: "62",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FDE8E1",
      d: "M61.03 29.452c.973.088 1.012 1.496.046 1.638l-8.11 1.19a22.9 22.9 0 0 0-19.482 20.587l-.74 8.163c-.089.973-1.496 1.012-1.638.045l-1.19-8.11A22.9 22.9 0 0 0 9.328 33.485l-8.162-.74c-.974-.09-1.012-1.497-.046-1.639l8.11-1.19A22.9 22.9 0 0 0 28.712 9.329l.74-8.163c.089-.973 1.496-1.012 1.638-.045l1.19 8.11A22.9 22.9 0 0 0 52.868 28.71z"
    }, null, -1)
  ])))
}
export default { render: render }